<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="20">
        <el-col :span="24">
          <el-card class="box-card">
            <h4 class="card-title">Details - The following classes will be used to generate the invoice</h4>
            <div class="card-header">

              <div class="card-content">


                <data-tables-server 
                  class="table-shopping" 
                  style="width: 100%" 
                  :data="classrooms" 
                  :tool-bar="false" 
                  :current-page="1" 
                  :total="total"
                  :loading="loadingInvoices"
                  :page-size="10"
                  :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }">

                  <el-table-column label="ID" min-width="10">
                    <template slot-scope="props">{{props.row.id}}</template>
                  </el-table-column>

                  <el-table-column label="Classroom Total" min-width="10">
                    <template slot-scope="props" v-if="tutors.length > 0">{{props.row.invoiceAmount | currentyCodeToSymbol(tutors[0].currency)}}</template>
                  </el-table-column>

                  <el-table-column label="Venue Name" min-width="10">
                    <template slot-scope="props">{{props.row.venue.name}}</template>
                  </el-table-column>

                  <el-table-column label="Invoice Paid" min-width="10">
                    <template slot-scope="props">
                      <small class="label label-success" v-if="props.row.invoicePaid === 1">Yes</small>
                      <small class="label label-danger" v-if="props.row.invoicePaid === 0">No</small>
                    </template>
                  </el-table-column>

                  <el-table-column label="Invoice Date" min-width="10">
                    <template slot-scope="props" v-if="props.row.invoiceDate != undefined">{{props.row.invoiceDate | moment('DD MMM YYYY')}}</template>
                  </el-table-column>

                </data-tables-server>
              </div>
            </div>
            <div class="card-content">
                <el-button type="secondary" @click="generateInvoice()">Generate Invoice</el-button>
                <el-button type="primary" @click="download">Download PDF</el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-row>

        <!-- PDF STUFF -->
        <el-card style="display:none;">
         <!-- IMAGES FOR PDF -->
        <img ref="teflogo" src="../../../static/img/tefl-org.png" width="100">
        <img ref="accreditation" src="../../../static/img/letterhead_accreditation.png" width="500">
        
        <div style="background:#fff; padding:20px;" v-if="tutors.length > 0 && classrooms.length > 0">
          <p ref="content1" v-if="tutors[0].address">
            Tutor:<br>
            {{tutors[0].firstname}} {{tutors[0].lastname}},<br>
            {{tutors[0].address.line1}},<br>
            {{tutors[0].address.town}},<br>
            {{tutors[0].address.postcode}}
          </p>
          <p ref="content1" v-else="">
            Tutor:<br>
            Jakob Brown,<br>
            37 Paisley Terrace,<br>
            Edinburgh,<br>
            EH8 7JW
          </p>
          <p ref="content2">
            Send to:<br>
            TEFL Org,<br />
            18 Alexander Place,<br />
            Inverness,<br />
            IV3 5BX
          </p>
        </div>
        <table id="my-table" class="el-table">
            <thead>
              <tr>
                <th width="80">Date</th>
                <th width="270">Venue</th>
                <th width="70">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(classroom, index) in classrooms" v-bind:key="index">
                <td>{{classroom.startDate | moment('DD MMM YYYY')}}</td>
                <td>{{classroom.venue.name}}, {{classroom.venue.town}} | {{classroom.length}} days</td>
                <td>{{classroom.invoiceAmount | currentyCodeToSymbol(tutors[0].currency)}}</td> 
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td></td>
                <td style="text-align:right; font-weight:700; padding-right:20px;">Bonus: </td>
                <td><span v-if="tutors.length > 0">{{calculateBonus() | currentyCodeToSymbol(tutors[0].currency)}}</span></td>
              </tr>
              <tr>
                <td></td>
                <td style="text-align:right; font-weight:700; padding-right:20px;">Total: </td>
                <td><span v-if="tutors.length > 0">{{calculateBonus() + calculateClassrooms() | currentyCodeToSymbol(tutors[0].currency)}}</span></td>
              </tr>
            </tfoot>
          </table>

          <p ref="footertext">
            TEFL Scotland LTD. Registered company in Scotland SC349721 | SQA approved centre number 3010171<br><br>
            Phone: 01349 800 600 | Email: info@tefl.org.uk
          </p>
          
        </el-card>

      </el-row>
    </el-main>
  </el-container>
</template>

<script>
//import InvoiceFilter from "../UIComponents/InvoiceFilter.vue";
//import VenueFilter from "../UIComponents/VenueFilter.vue";
import api from "./api";
import jsPDF from 'jspdf'
import 'jspdf-autotable';
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
import axios from "axios";

export default {
  data() {
    return {
      total: 0,
      invoice: {},
      tutors: [],
      classrooms: [],
      loadingInvoices: false,
      loadingClassrooms: false,
      loadingTutors: false
    };
  },
  methods: {

    getClassrooms() {

    var id = this.$route.params.id
    this.loadingClassrooms = true;

      this.$apollo
      .query({
        query: gql`
        {
          ClassRoom(
              order_by: {startDate:asc},
              where: { 
                  _and: [
                    { invoicePaid: {_eq: 0} },
                    { invoiceAmount: {_gt: 0} },
                    { isPublic: {_eq: 0} },
                    { tutor: {id : {_eq: ${id}}} }
                  ]
                }
            ) {
            id
            code
            isPublic
            length
            maxAttendees
            numAttendees
            venueId
            tutorId
            startDate
            endDate
            invoiceAmount
            invoiceBonus
            invoiceDate
            invoicePaid
            invoicePaidDate
            numberOfTens
            recommendedPercentage
            serviceRatingPercentage
            tutorRatingPercentage
            tutorId
            feedbackCount
            tutor {
              id
              firstname
              lastname
              email
            }
            venue {
              id
              town
              region
              country
              name
              line1
            }
            attendees {
              customer {
                id
                firstname
                lastname
              }
            }
          }
        }`,
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        console.log(response.data.ClassRoom)
        this.classrooms = response.data.ClassRoom;
        this.loadingClassrooms = false;
      });
    },

    uniqueID() {
        // Math.random should be unique because of its seeding algorithm.
        // Convert it to base 36 (numbers + letters), and grab the first 9 characters
        // after the decimal.
        return 'invoice_' + Math.random().toString(36).substr(2, 9);
    },

    getTutors() {

      var id = this.$route.params.id
      this.loadingTutors = true;

      this.$apollo
      .query({
        query: gql`
        {
          Tutor(
            limit: 1,
            where: {id: {_eq: ${id}}}
          ) {
            id
            firstname
            lastname
            currency
            email
            rating
            isActive
            canLogin
            address {
              id
              line1
              line2
              country
              town
              phone
            }
          
          }
        }`,
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        this.tutors = response.data.Tutor;
        this.loadingTutors = false;
      });
    },

    calculateBonus(){
      var bonusTotal = 0;
      var rating = this.tutors[0].rating

      if(rating >= 99) {
          bonusTotal = 50;
      } else if(rating >= 90) {
          bonusTotal = 40;
      } else if(rating >= 80) {
          bonusTotal = 30;
      } else if(rating >= 70) {
          bonusTotal = 20;
      }

      return bonusTotal
    },

    calculateClassrooms(){
      var i;
      var classRoomTotal = 0
      for (i = 0; i < this.classrooms.length; i++) {
          classRoomTotal += this.classrooms[i].invoiceAmount;
          //SET INVOICE FIELDS ON THE CLASSROOM TO PAID AND ADD THE DATE
          //this.updateInvoice(this.classrooms[i].id);
      }
      return classRoomTotal
    },

    generateInvoice(){

        var tutorId = this.$route.params.id
        var uniqid = this.uniqueID()
        var dateCreated = moment().format("YYYY-MM-DD");
        var dateUpdated = moment().format("YYYY-MM-DD");
        var invoiceDate = moment().format("YYYY-MM-DD");
        
        //Set default values
        var invoiceTotal = 0;
        var classRoomTotal = 0;
        var bonusTotal = 0;

        //Calculate bonus
        bonusTotal = calculateBonus()

        //Calculate Classroom Totals
        classRoomTotal = calculateClassrooms();

        //Set invoice total
        invoiceTotal = classRoomTotal + bonusTotal;

        var sign = '£';
        var currency = this.tutors[0].currency;
        switch (currency) {
            case 'GBP':
                sign = "£";
                break;
            case 'EUR':
                sign = "€";
                break;
            case 'USD':
                sign = "$";
                break;
            default:
                sign = "£";
                break;
        }
        
        var sourceUrl = 'application/assets/pdfs/invoices/'+uniqid+'.pdf';
        var isPaid = 0;
        var paidDate = null;

       // console.dir(this.currentPrice.prices[2])
        const q = gql`
          mutation insert_TutorInvoice(
            $tutorId: Int, 
            $invoiceTotal: float8, 
            $dateCreated: timestamp, 
            $dateUpdated: timestamp,
            $invoiceDate: timestamp,
            $classRoomTotal: float8,
            $bonusTotal: float8,
            $sourceUrl: String,
            $isPaid: smallint,
            $paidDate: timestamp, 
          ) {
            insert_TutorInvoice(objects: {
              tutorId: $tutorId, 
              invoiceTotal: $invoiceTotal, 
              dateCreated : $dateCreated, 
              dateUpdated : $dateUpdated,
              invoiceDate : $invoiceDate,
              classRoomTotal: $classRoomTotal,
              bonusTotal: $bonusTotal,
              sourceUrl: $sourceUrl,
              isPaid: $isPaid,
              paidDate: $paidDate
            }) {
              affected_rows
              returning {
                id
              }
            }
          }
      `;

      this.$apollo
      
      .mutate({
        mutation: q,
        variables: {
          tutorId: tutorId,
          invoiceTotal: invoiceTotal,
          dateCreated: dateCreated,
          dateUpdated: dateUpdated,
          invoiceDate: invoiceDate,
          classRoomTotal: classRoomTotal,
          bonusTotal: bonusTotal,
          sourceUrl: sourceUrl,
          isPaid: isPaid,
          paidDate: paidDate
        }
      })

      .then(result => {
        this.$notify({
          title:"Invoice Saved",
          message: "Invoice saved successfully",
          type: "success"
        });
        //this.getRegister(this.$route.params.id);
        // return result
      })
      .catch(error => {
        this.$notify({
          title: "Error",
          message: error.message,
          type: "error"
        });
      });
    },

    updateInvoice(id){

       var invoicePaidDate = moment().format("YYYY-MM-DD");
       var invoicePaid = 1;

       // console.dir(this.currentPrice.prices[2])
        const q = gql`
          mutation update_ClassRoom($id: Int, $invoicePaid: smallint, $invoicePaidDate: timestamp) {
            update_ClassRoom(where: { id: { _eq: $id } }, _set: {invoicePaid : $invoicePaid, invoicePaidDate: $invoicePaidDate}) {
              affected_rows
              returning {
                id
                code
                isPublic
                length
                maxAttendees
                numAttendees
                venueId
                tutorId
                startDate
                endDate
                invoiceAmount
                invoiceBonus
                invoiceDate
                invoicePaid
                invoicePaidDate
                numberOfTens
                recommendedPercentage
                serviceRatingPercentage
                tutorRatingPercentage
                tutorId
                feedbackCount
                tutor {
                  id
                  firstname
                  lastname
                  email
                }
                venue {
                  id
                  town
                  region
                  country
                  name
                  line1
                }
                attendees {
                  customer {
                    id
                    firstname
                    lastname
                  }
                }
              }
            }
          }
      `;

      this.$apollo
      
      .mutate({
        mutation: q,
        variables: {
          id: id,
          invoicePaid: invoicePaid,
          invoicePaidDate: invoicePaidDate
        }
      })

      .then(result => {
        this.$notify({
          title:"Success",
          message: "Classroom updated",
          type: "success"
        });
        //this.classroom = result.data.update_ClassRoom.returning
        //this.getRegister(this.$route.params.id);
        // return result
      })
      .catch(error => {
        this.$notify({
          title: "Error",
          message: error.message,
          type: "error"
        });
      });
    },

    download() {

      //const doc = new jsPDF();

      var logo = new Image();
      var accreditation = new Image();
      logo.src = this.$refs.teflogo.src;
      accreditation.src = this.$refs.accreditation.src;

      const content1 = this.$refs.content1.textContent;
      const content2 = this.$refs.content2.textContent;
      const footertext = this.$refs.footertext.textContent;
      //const imgData = 'data:image/jpeg;base64,'+ Base64.encode(this.$refs.teflogo.src);
      //const accreditationData = 'data:image/jpeg;base64,'+ Base64.encode(this.$refs.accreditation.src);

      var doc = new jsPDF();

      doc.setFontSize(18);
      //150 to right align logo
      doc.addImage(logo, 'JPEG', 15, 10, 38, 28);
      doc.text('Classroom Tutor Invoice', 15, 60);
      doc.setFontSize(11);
      doc.setTextColor(100);
      
      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      var pageSize = doc.internal.pageSize;
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
      var text1 = doc.splitTextToSize(content1, pageWidth - 35, {});
      var text2 = doc.splitTextToSize(content2, pageWidth - 35, {});
      doc.text(text1, 5, 68);
      doc.text(text2, 100, 68)

      doc.autoTable({
          startY: 108, 
          html:"#my-table"
      });

      // Footer
      var str = "Invoice generated on " + moment().format("DD/MM/YYYY HH:MM");
      doc.setFontSize(10);

      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      var pageSize = doc.internal.pageSize;
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
      var footer = doc.splitTextToSize(footertext, pageWidth - 35, {});
      doc.addImage(accreditation, 'JPEG', 0, pageHeight - 55, 200, 20);
      doc.text(footer, (pageWidth/2)-5, pageHeight - 30, 'center');
      doc.text(str, (pageWidth/2)-5, pageHeight - 10, 'center');

      var uniqid = this.uniqueID()

      //doc.text(content1, 5, doc.autoTable.previous.finalY + 10);

      // File upload
      // var pdf = btoa(doc.output()); 
      var pdf = doc.output('blob');
      // var pdf = doc.output();
      // var pdf = doc.output('arraybuffer');

      doc.save(uniqid + '.pdf');
      this.handleUpload(pdf, uniqid);

    },

    async handleUpload(pdf, uniqid) {
      console.log(pdf);
      const form_data = new FormData();
      form_data.append('data', pdf, uniqid + '.pdf');
      //form_data.append('files', pdf, uniqid + '.pdf');
      console.log(form_data)

      const response = await axios.post(`http://localhost:3010/storage/upload`, form_data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-path': '/invoices/'
        },
        withCredentials: true,
      })

      /*
      // Async request to upload invoice from backend
      axios.post(`http://localhost:3010/storage/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          // 'x-path': '/invoices/'
        },
        withCredentials: true,
      })
      .then(response => {
        console.log(response);
      })
      .catch(err => {
        console.log(err);
      });
      */
      
      console.log({response})

      const inserted_file = response.data[0];

    }
    
  },
  mounted() {
    this.getTutors();
    this.getClassrooms();
    //this.generateInvoice();
  },
  watch: {
    "this.$route.params.id": function(id) {
      console.log('watching...')
      this.getTutors();
      this.getClassrooms();
    }
  },

};
</script>


// WEBPACK FOOTER //
// src/components/Tutor/Generate.vue